export type DocumentLineForm = {
  key: string;
  companyId: string;
  accountId: string;
  debitLocal: string;
  creditLocal: string;
  currencyId: string;
  rate: string;
  debitUSD: string;
  creditUSD: string;
  narrative: string;
  plPeriodFrom: string;
  plPeriodTo: string;
  dn: string;
  notes: string;
  linkNumber: string;
  dueDate: string;
  allowOpenItems?: boolean;
  /** Open balance at pick time (payment form — max pay now). */
  openBalance?: string;
};

export const newDocumentLine = (): DocumentLineForm => ({
  key: `line-${Date.now()}-${Math.random()}`,
  companyId: '',
  accountId: '',
  debitLocal: '',
  creditLocal: '',
  currencyId: '',
  rate: '',
  debitUSD: '',
  creditUSD: '',
  narrative: '',
  plPeriodFrom: '',
  plPeriodTo: '',
  dn: '',
  notes: '',
  linkNumber: '',
  dueDate: '',
});
